import {CustomEventHandler} from "../../utils/CustomEventHandler";
import {MathUtil} from "../../utils/MathUtil";
import barba from "@barba/core";
import {isBarba} from "../../common/globalVars";
import {HtmlUtil} from "../../utils/HtmlUtil";

const MOVE_TYPE_NONE = 0;
const MOVE_TYPE_H = 1;
const MOVE_TYPE_V = 2;

export default class MobileSlider {
    constructor(el) {
        this.el = el;
        this.container = this.el.querySelector('.slider-container');
        this.totalIdx = el.querySelectorAll('.component-slider-item').length - 1;
        this.curIdx = 0;
        this.curTargetEl = '';

        this.isDrag = false;
        this.isEnable = false;
        this.moveType = MOVE_TYPE_NONE;

        this.startX = 0;
        this.startY = 0;

        this.defaultX = 0;
        this.targetX = 0;
        this.moveX = 0;
        this.itemWidth = 0;

        this.init();
    }

    init() {
        this.addEvent();
    }

    addEvent() {
        CustomEventHandler.addHandler(this.container, 'mousedown', (e)=>this.onDownHandler(e), false );
        CustomEventHandler.addHandler(this.container, 'mousemove', (e)=>this.onMoveHandler(e), false );
        CustomEventHandler.addHandler(this.container, 'mouseup', (e)=>this.onUpHandler(e), false );
        CustomEventHandler.addHandler(this.container, 'mouseleave', (e)=>this.onUpHandler(e), false );

        CustomEventHandler.addHandler(this.container, 'touchstart', (e)=>this.onDownHandler(e), false );
        CustomEventHandler.addHandler(this.container, 'touchmove', (e)=>this.onMoveHandler(e), false );
        CustomEventHandler.addHandler(this.container, 'touchend', (e)=>this.onUpHandler(e), false );
        CustomEventHandler.addHandler(this.container, 'touchcancel', (e)=>this.onUpHandler(e), false );

        this.onResizeHandler();
        CustomEventHandler.addHandler(window, 'resize', ()=>this.onResizeHandler());
    }

    setEnable() {
        this.isEnable = true;
        this.setSnap();
        this.setX(true);
        this.moveType = MOVE_TYPE_NONE;
    }

    setDisable() {
        this.isEnable = false;
        this.targetX = 0;
        this.setX(false);
    }

    setPrev() {
        this.curIdx = this.curIdx<=0? 0: this.curIdx-1;
        this.setSnap();
        this.setX(true);
    }

    setNext() {
        this.curIdx = this.curIdx>=this.totalIdx? this.totalIdx: this.curIdx+1;
        this.setSnap();
        this.setX(true);
    }

    getTargetEl(e) {
        let targetLi = e.target.parentElement.parentElement;
        if (targetLi.tagName === 'LI') {
            return targetLi;
        }
        return undefined;
    }

    setClick(el) {
        // console.log(el.getAttribute('data-link'));
        if (!el) return;
        let link = el.getAttribute('data-link');
        HtmlUtil.goLink(link);
    }

    onDownHandler(e) {
        this.curTargetEl = this.getTargetEl(e);
        if (!this.isEnable) return;

        this.isDrag = true;
        this.startX = this.getPos(e).x;
        this.startY = this.getPos(e).y;
        this.moveX = this.startX;
    }

    onMoveHandler(e) {
        if (!this.isEnable) return;
        if (!this.isDrag) return;

        let diff = this.moveX - this.getPos(e).x;
        this.targetX -= diff;
        this.moveX = this.getPos(e).x;

        if ( Math.abs(this.startX - this.getPos(e).x) > 10) {
            this.moveType = MOVE_TYPE_H;
            e.preventDefault();
        } else if ( Math.abs(this.startY - this.getPos(e).y) > 10) {
            this.moveType = MOVE_TYPE_V;
            this.setSnap();
            this.setX(true);
            this.isDrag = false;
            return
        }

        this.setX(false);
    }

    onUpHandler(e) {
        //모바일 사이즈가 아닌 상태에서 클릭했을 경우
        if (!this.isEnable) {
            if (this.curTargetEl === this.getTargetEl(e)) {
                this.setClick(this.curTargetEl);
            }
        }

        if (!this.isDrag) return;

        this.isDrag = false;
        let diff = this.moveX - this.startX;

        if (diff>10) {
            this.setPrev();
            e.preventDefault();
            return false;
        } else if (diff<-10) {
            this.setNext();
            e.preventDefault();
            return false;
        } else {
            this.setSnap();
            this.setX(true);
        }

        //모바일 사이즈에서 클릭했을 경우
        if (Math.abs(diff) < 5) {
            this.setClick(this.curTargetEl);
        }
    }

    onResizeHandler() {
        this.itemWidth = this.el.querySelector('.component-slider-item').getBoundingClientRect().width;
        this.maxX = this.itemWidth * this.totalIdx * -1;
        this.setSnap();
        this.setX(false);
        
    }

    setFix() {
        this.targetX = MathUtil.lerp(this.maxX, 0, this.targetX);
    }

    setSnap() {
        this.targetX = this.curIdx * this.itemWidth * -1;
    }

    setX(isAnimate) {
        if (!this.isEnable) return;

        let duration = isAnimate?0.3:0;
        this.container.style.transition = `transform ${duration}s ease-out`;
        this.container.style.transform = `translate3d( ${this.targetX}px, 0, 0)`;
    }

    getPos(e) {
        if (e.type.includes('touch')) {
            return {
                x:e.targetTouches[0].clientX,
                y:e.targetTouches[0].clientY
            };
        }
        return {
            x:e.clientX,
            y:e.clientY
        };
    }
}
